// src/Models/ticketModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID, Dttm).
// -----------------------------------------------------------------------------

export class TicketModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      ticketID: data.ticketId || data.ticketID,
      ticketNumber: data.ticketNumber,
      projectID: data.projectId || data.projectID,
      phaseID: data.phaseId || data.phaseID,
      ticketTypeID: data.ticketTypeId || data.ticketTypeID,
      ticketSubTypeID: data.ticketSubTypeId || data.ticketSubTypeID,
      title: data.title,
      description: data.description,
      detailedDescription: data.detailedDescription,
      severityID: data.severityId || data.severityID,
      statusID: data.statusId || data.statusID,
      environmentID: data.environmentId || data.environmentID,
      raisedBy: data.raisedBy,
      clientOrgID: data.clientOrgId || data.clientOrgID,
      reopenReasonID: data.reopenReasonId || data.reopenReasonID,
      reopenCount: data.reopenCount || 0,
      createDate: data.createDate || data.createdDate || data.createDttm,
      resolvedDate: data.resolvedDate,
      lastUpdateDttm: data.lastUpdateDttm,
      lastUpdatedBy: data.lastUpdatedBy,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      ticketId: Number(data.ticketID || data.ticketId || 0),
      ticketNumber: data.ticketNumber || '',
      projectId: data.projectID || data.projectId ? Number(data.projectID || data.projectId) : null,
      phaseId: data.phaseID || data.phaseId ? Number(data.phaseID || data.phaseId) : null,
      ticketTypeId: data.ticketTypeID || data.ticketTypeId ? Number(data.ticketTypeID || data.ticketTypeId) : null,
      ticketSubTypeId: data.ticketSubTypeID || data.ticketSubTypeId ? Number(data.ticketSubTypeID || data.ticketSubTypeId) : null,
      title: data.title || '',
      description: data.description || '',
      detailedDescription: data.detailedDescription || '',
      severityId: data.severityID || data.severityId ? Number(data.severityID || data.severityId) : null,
      statusId: data.statusID || data.statusId ? Number(data.statusID || data.statusId) : 1, // Default to 1 (Open)
      environmentId: data.environmentID || data.environmentId ? Number(data.environmentID || data.environmentId) : null,
      raisedBy: data.raisedBy ? Number(data.raisedBy) : 1, // Default to 1
      clientOrgId: data.clientOrgID || data.clientOrgId ? Number(data.clientOrgID || data.clientOrgId) : null,
      reopenReasonId: data.reopenReasonID || data.reopenReasonId ? Number(data.reopenReasonID || data.reopenReasonId) : null,
      reopenCount: Number(data.reopenCount || 0),
      createDate: data.createDate || new Date().toISOString(),
      resolvedDate: data.resolvedDate || null,
      lastUpdateDttm: new Date().toISOString(),
      lastUpdatedBy: data.lastUpdatedBy ? Number(data.lastUpdatedBy) : 1,
    };
  }
}
